import Test from '../../components/icons/Test';
import { QuestionOptions, QuestionSchema } from './Questions.types';

export function getIcon(questionSchema: QuestionSchema) {
    const MyIcon = questionSchema?.icon || Test;
    return ({ className }: { className?: string }) => (
        <div className={className}>
            <MyIcon />
        </div>
    );
}

export function getOptionsFromList(options: QuestionOptions) {
    return options.map(opt => opt?.trim()).filter(opt => !!opt);
}

export function getFormQuestionSchema(question, objectSchema) {
    return objectSchema.filter(o => o.key === `question-${question.id}`)[0];
}

export function isSchedulingAnswerValid(answer) {
    return answer && answer[0]?.startTime && !answer[0]?.zeroQuantity;
}
